import { getLatestDateFromData } from "./utils";

export function getLastUpdatedOn(data, nodeId) {
  const lastUpdatedData = data.filter((item) => item.nid === `${nodeId}`);
  // If no matching items found, return null or a default value
  if (lastUpdatedData.length === 0) {
    return `No Data Found`; // or return a default date if you prefer
  }
  // Get the latest date from the filtered data
  return getLatestDateFromData(lastUpdatedData);
}
